export const galleryCategories = [
  { id: 'all' },
  { id: 'wedding' },
  { id: 'pre-wedding' },
  { id: 'baby' },
  { id: 'corporate' },
  { id: 'portrait' },
  { id: 'event' },
]

export const galleryItems = [
  {
    id: 'g1',
    category: 'wedding',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20and%20groom%20in%20traditional%20red%20silk%20saree%20and%20veshti%20during%20a%20temple%20wedding%20ceremony%2C%20warm%20golden%20lighting%2C%20candid%20emotional%20moment%2C%20cinematic%20editorial%20photography%2C%20rich%20warm%20tones%2C%20soft%20bokeh%20background&width=900&height=1100&seq=shabi-wed-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g2',
    category: 'wedding',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20Tamil%20bride%20portrait%20with%20traditional%20temple%20gold%20jewellery%20and%20red%20silk%20saree%2C%20golden%20hour%20backlight%2C%20elegant%20luxury%20photography%2C%20warm%20amber%20tones%2C%20soft%20dark%20background%2C%20high%20detail%20editorial%20look&width=900&height=1100&seq=shabi-wed-02&orientation=portrait&nocache=true',
  },
  {
    id: 'g3',
    category: 'pre-wedding',
    image:
      'https://readdy.ai/api/search-image?query=young%20South%20Indian%20Tamil%20couple%20silhouette%20holding%20hands%20on%20a%20beach%20at%20sunset%2C%20dramatic%20warm%20orange%20sky%2C%20cinematic%20pre-wedding%20photography%2C%20wide%20romantic%20composition%2C%20soft%20glow%20and%20gentle%20gradient&width=900&height=1100&seq=shabi-prewed-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g4',
    category: 'pre-wedding',
    image:
      'https://readdy.ai/api/search-image?query=candid%20young%20South%20Indian%20Tamil%20couple%20laughing%20together%20in%20a%20lush%20green%20garden%2C%20engagement%20photo%20shoot%2C%20natural%20daylight%2C%20warm%20cinematic%20grade%2C%20joyful%20expression%2C%20soft%20blurred%20foliage%20backdrop&width=900&height=1100&seq=shabi-prewed-02&orientation=portrait&nocache=true',
  },
  {
    id: 'g5',
    category: 'baby',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20newborn%20baby%20sleeping%20peacefully%20wrapped%20in%20a%20soft%20cream%20blanket%2C%20warm%20neutral%20studio%20lighting%2C%20tender%20minimal%20newborn%20photography%2C%20soft%20ivory%20background%2C%20gentle%20highlights&width=900&height=1100&seq=shabi-baby-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g6',
    category: 'baby',
    image:
      'https://readdy.ai/api/search-image?query=happy%20South%20Indian%20Tamil%20toddler%20celebrating%20first%20birthday%20with%20a%20small%20cake%2C%20candid%20joyful%20expression%2C%20warm%20studio%20lighting%2C%20soft%20cream%20and%20gold%20decor%2C%20bright%20cheerful%20editorial%20photography&width=900&height=1100&seq=shabi-baby-02&orientation=portrait&nocache=true',
  },
  {
    id: 'g7',
    category: 'corporate',
    image:
      'https://readdy.ai/api/search-image?query=professional%20South%20Indian%20business%20conference%20stage%20with%20speaker%20and%20audience%2C%20corporate%20event%20photography%2C%20clean%20modern%20lighting%2C%20warm%20neutral%20tones%2C%20sharp%20editorial%20composition&width=900&height=1100&seq=shabi-corp-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g8',
    category: 'corporate',
    image:
      'https://readdy.ai/api/search-image?query=confident%20South%20Indian%20Tamil%20business%20executive%20studio%20headshot%2C%20clean%20neutral%20background%2C%20professional%20corporate%20portrait%20lighting%2C%20warm%20subtle%20tones%2C%20sharp%20and%20polished&width=900&height=1100&seq=shabi-corp-02&orientation=portrait&nocache=true',
  },
  {
    id: 'g9',
    category: 'portrait',
    image:
      'https://readdy.ai/api/search-image?query=cinematic%20studio%20portrait%20of%20a%20South%20Indian%20Tamil%20woman%20in%20a%20silk%20saree%2C%20dramatic%20side%20lighting%2C%20dark%20warm%20brown%20background%2C%20elegant%20fashion%20photography%2C%20rich%20contrast%20and%20golden%20tones&width=900&height=1100&seq=shabi-pf-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g10',
    category: 'portrait',
    image:
      'https://readdy.ai/api/search-image?query=moody%20fashion%20portrait%20of%20a%20young%20South%20Indian%20Tamil%20man%20in%20a%20stylish%20jacket%2C%20dramatic%20low%20key%20lighting%2C%20deep%20brown%20tones%2C%20editorial%20magazine%20style%2C%20sharp%20texture%20detail&width=900&height=1100&seq=shabi-pf-02&orientation=portrait&nocache=true',
  },
  {
    id: 'g11',
    category: 'event',
    image:
      'https://readdy.ai/api/search-image?query=vibrant%20South%20Indian%20cultural%20stage%20event%20with%20warm%20lights%20and%20a%20celebrating%20crowd%2C%20concert%20and%20cultural%20program%20photography%2C%20dramatic%20golden%20lighting%2C%20energetic%20cinematic%20moment&width=900&height=1100&seq=shabi-ev-01&orientation=portrait&nocache=true',
  },
  {
    id: 'g12',
    category: 'event',
    image:
      'https://readdy.ai/api/search-image?query=South%20Indian%20award%20ceremony%20moment%20with%20people%20applauding%20and%20warm%20stage%20lighting%2C%20elegant%20event%20photography%2C%20rich%20amber%20tones%2C%20candid%20celebration%2C%20soft%20bokeh%20highlights&width=900&height=1100&seq=shabi-ev-02&orientation=portrait&nocache=true',
  },
]